import { Tab, Tabs } from '../../components';
import { usePermissionAllowed } from '../../hooks';
import {
  CorporateAgentSettings,
  SmartActionsFormInputs,
} from '../../components/AgentForm/components';
import NewAgentPage from './NewAgentFormTab';
import { PERMISSIONS } from '../../shared/constants/permissions';
import type { AgentProps } from '../agent/AgentFormTab/AgentFormTab';

export type NewAgentTabEnum =
  | 'agentSettings'
  | 'smartAtions'
  | 'corporateSettings';

export type AgentTabsProps = AgentProps & {
  knowledgeData: OptionType[];
  activeTab: NewAgentTabEnum;
  setActiveTab: (tab: NewAgentTabEnum) => void;
};

export const NewAgentTabs: React.FC<AgentTabsProps> = ({
  agent,
  form,
  loading,
  onSubmit,
  onChange,
  editing,
  knowledgeData,
  setActiveTab,
  activeTab,
  ...rest
}) => {
  const editDisabled = !usePermissionAllowed([PERMISSIONS.EDIT_AGENTS]);

  return (
    <div>
      <Tabs
        tabs={[
          { name: 'agentSettings', label: 'Agent Settings' },
          { name: 'smartAtions', label: 'Smart Actions' },
          { name: 'corporateSettings', label: 'Corporate Agent Settings' },
        ]}
        tabsClassName="w-fit text-secondary border-b border-gray-200"
        contentClassName="mt-md"
        activeTab={activeTab}
        onChange={setActiveTab}
      >
        <Tab name="agentSettings">
          <NewAgentPage
            {...rest}
            form={form!}
            onChange={onChange}
            loading={loading}
            editDisabled={editDisabled}
          />
        </Tab>
        <Tab name="smartAtions">
          <SmartActionsFormInputs
            form={form!}
            disabled={editDisabled}
            knowledgeData={knowledgeData}
          />
        </Tab>
        <Tab name="corporateSettings">
          <CorporateAgentSettings form={form!} disabled={editDisabled} />
        </Tab>
      </Tabs>
    </div>
  );
};
